import { toast } from "react-toastify";

const defaultErrorHandler = (error, type, asNotifications = true) => {
    const errorMessages = [];
    if (error.response && error.response.data) {
        if (error.response.data.message && typeof error.response.data.message === "string") {
            errorMessages.push(error.response.data.message);
        } else if (typeof error.response.data === "object") {
            Object.keys(error.response.data).map(key =>
                errorMessages.push(error.response.data[key]));
        }
    } else if (error.message && typeof error.message === "string") {
        errorMessages.push(error.message);
    }

    if (asNotifications) {
        errorMessages.forEach((message) => {
            if (typeof message === "string") {
                toast(message, {
                    type: toast.TYPE.ERROR,
                    autoClose: 3000
                });
            }
        });
        return {
            type,
            payload: []
        };
    }

    return {
        type,
        payload: errorMessages
    };
};

export default defaultErrorHandler;



// WEBPACK FOOTER //
// ./src/actions/global/default-error-handler.js